import { FC } from "react";
import Button from "@mui/material/Button";

type PropsButtonSubmitA = {
  name: string;
  icon?: any;
  disabled?: boolean;
};

const ButtonAStyle = {
  backgroundColor: "#203C77",
  color: "#fff",
  borderRadius: "50px",
  minWidth: "100px",
  textTransform: "capitalize",

  "&:hover": {
    backgroundColor: "#203C77",
  },
};

export const ButtonSubmitA: FC<PropsButtonSubmitA> = ({ name, icon, disabled }) => {
  return (
    <Button sx={ButtonAStyle} type="submit" disabled={disabled}>
      {icon}{name}
    </Button>
  );
};
